<script setup lang="ts">
const { stepIndex, activeIndex } = defineProps<{
  stepIndex: number
  activeIndex: number
  step: RegisterUserHeaderStepId
}>()

const state = computed(() => {
  if (activeIndex - stepIndex === 1) {
    return 'last'
  }
  else if (stepIndex < activeIndex) {
    return 'completed'
  }
  else if (stepIndex === activeIndex) {
    return 'current'
  }
  else {
    return 'upcoming'
  }
})
</script>

<template>
  <div
    :data-step="state"
    class="flex gap-[10px] items-center text-base no-underline flex-grow"
  >
    <span
      class="rounded-full size-6 aspect-square flex items-center justify-center border-2 transition-colors duration-300"
      :class="[
        state === 'upcoming' ? 'text-blurple-200' : 'text-blurple-500',
        {
          'bg-blurple-200 border-blurple-200': ['last', 'completed'].includes(state),
          'bg-white border-white font-bold': state === 'current',
          'border-blurple-400': state === 'upcoming',
        },
      ]"
      v-text="stepIndex + 1"
    />

    <span
      class="text-nowrap transition-colors duration-300"
      :class="state === 'current' ? 'text-white' : 'text-blurple-200'"
      v-text="REGISTER_USER_STEP_LABELS[step]"
    />
  </div>
</template>

<style scoped lang="postcss">
[data-step] {
  &:before,
  &:after {
    @apply content-[''] w-full transition-colors duration-300;

    height: 2px;
  }

  &:before {
    @apply rounded-r-md;
  }

  &:after {
    @apply rounded-l-md;
  }
}

[data-step]:first-of-type:before {
  @apply rounded-l-md;
}

[data-step]:last-of-type:after {
  @apply hidden;
}

[data-step='completed'] {
  &:before,
  &:after {
    @apply bg-blurple-200;
  }
}

[data-step='last'] {
  &:before {
    @apply bg-blurple-200;
  }

  &:after {
    @apply bg-white;
  }
}

[data-step='current'] {
  &:before {
    @apply bg-white;
  }

  &:after {
    @apply bg-blurple-400;
  }
}

[data-step='upcoming'] {
  &:before,
  &:after {
    @apply bg-blurple-400;
  }
}
</style>
